
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/rewards-join",
      function () {
        return require("private-next-pages/rewards-join.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/rewards-join"])
      });
    }
  